import React from 'react';

const CrossIcon = (props: object) => {
  return (
    <svg
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.5872 17.4125L16.25 18.0755L17.5759 16.7497L16.9129 16.0868L11.3258 10.4997L16.9129 4.91257L17.5759 4.24965L16.25 2.92383L15.5872 3.58674L10 9.17383L4.41293 3.58674L3.75002 2.92383L2.42419 4.24965L3.08711 4.91257L8.67419 10.4997L3.08711 16.0868L2.42419 16.7497L3.75002 18.0755L4.41293 17.4125L10 11.8255L15.5872 17.4125Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default CrossIcon;
